import axios from "axios";
import {Keys} from '/src/config.js'

axios.defaults.baseURL = Keys.VUE_APP_API_URL + "/api"; // change this if you want to use a different url for APIs
axios.defaults.withCredentials = true;
/*
 * Only when there is one.
 *
 * localStorage.getItem returns null when nothing was stored and the string
 * "null" after a sign-out, and both were being pasted into the header - so
 * every request from a signed-out browser carried Bearer null, which the
 * licence check then tried to hex-decode.
 */
const token = localStorage.getItem('freshToken');
if (token && token !== 'null' && token !== 'undefined') {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}
